// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_ENTRIES = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1tov"];
export const counter_RATINGS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
